// extracted by mini-css-extract-plugin
export var container = "testimonials-module--container--JjhZy";
export var headlineTop = "testimonials-module--headlineTop--9Rd+n";
export var headlineBottom = "testimonials-module--headlineBottom--8YBbf";
export var inner = "testimonials-module--inner--NtErA";
export var title = "testimonials-module--title--OTqTh";
export var card = "testimonials-module--card--x2iQh";
export var cardStars = "testimonials-module--cardStars--tPhkt";
export var cardBody = "testimonials-module--cardBody--uQO33";
export var cardName = "testimonials-module--cardName--gkRZ6";